import { createFileRoute, redirect } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { resolveCurrentSiteId } from "@/hooks/useLastSelectedSite";

const searchSchema = z.object({
  producer: z.string().optional(),
  page: z.number().int().positive().optional(),
});

export const Route = createFileRoute("/_auth/settings/notification-rejects")({
  validateSearch: zodValidator(searchSchema),
  beforeLoad: ({ context, search }) => {
    const siteId = resolveCurrentSiteId(context.auth?.sites ?? []);
    if (!siteId) throw redirect({ to: "/", replace: true });
    throw redirect({
      to: "/settings/$siteId/notifications",
      params: { siteId },
      search: { tab: "rejects", producer: search.producer, page: search.page },
      replace: true,
    });
  },
});
